/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrSddcProviderEnum } from './irrSddcProviderEnum';
import { IrrOrgAuthProvider } from './irrOrgAuthProvider';


export interface IrrSddcNetwork { 
    provider?: IrrSddcProviderEnum;
    console?: string;
    backend?: string;
    authProvider?: IrrOrgAuthProvider;
    cspConsole?: string;
    cspBackend?: string;
    availabilityZones?: Array<string>;
}
export namespace IrrSddcNetwork {
}


